type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';
const BASE_URL = 'https://api.frontendmonitoring.com';
type Data = Record<string, unknown>;

/**
 * Sends an HTTP request to the server. Every request should go through this,
 * so that we can add common functionality like authentication headers, tracking,
 * or error handling.
 *
 * @param {HttpMethod} method - The HTTP method to use (GET, POST, PUT, DELETE).
 * @param {string} endpoint - The endpoint to send the request to.
 * @param {Data} data - Optional data to include in the request body.
 *
 * @returns {Promise} A Promise that resolves with the response data.
 *
 * @throws {Error} If the response status is not OK.
 */
const request = async (method: HttpMethod, endpoint: string, data?: Data) => {
  const anonKey =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZyZ25xYWdwb2F2cmR1eWJwYmZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDE5MTY0MDMsImV4cCI6MjAxNzQ5MjQwM30.OVxxYZUtGGhasdj3J1cTFxn4ImbbfpVVi4wYWP-_lAw';

  const accessToken = localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken || anonKey}`,
    apikey: anonKey,
    'X-ACCESS-TOKEN': localStorage.getItem('access_token') || '',
    'X-REFRESH-TOKEN': localStorage.getItem('refresh_token') || ''
  };

  const response: Response = await fetch(`${BASE_URL}/${endpoint}`, {
    method: method,
    headers,
    body: JSON.stringify(data)
  });

  const jsonData = await response.json();

  // TODO: Handle 401s better
  if (response.status === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
  if (!response.ok) {
    localStorage.removeItem('userjwt');
    // TODO: Redirect or retry login
    throw {
      status: response.status,
      ...jsonData
    };
  }

  return jsonData;
};

const http = {
  get: async (endpoint: string, data?: Data) => {
    return request('GET', endpoint, data);
  },
  post: async (endpoint: string, data?: Data) => {
    return request('POST', endpoint, data);
  },
  put: async (endpoint: string, data?: Data) => {
    return request('PUT', endpoint, data);
  },
  delete: async (endpoint: string, data?: Data) => {
    return request('DELETE', endpoint, data);
  }
};

export default http;
